<template>
  <section id="content" ref="filesContent">
    <PageTitle :title="$t('intrastats.files.title')"></PageTitle>
    <div class="wrapper wrapper-content animated fadeInRight">

      <Header></Header>

      <div class="row" v-if="selectedModule">
        <div class="col-lg-12">
          <CheckedFiles></CheckedFiles>
        </div>
      </div>

      <div class="row" v-if="selectedModule">
        <div class="col-lg-12">
          <GeneratedFiles></GeneratedFiles>
        </div>
      </div>

    </div>
  </section>
</template>

<style scoped>

</style>



<script lang="ts">
import { Ref, defineComponent, PropType, computed, onMounted, onBeforeUnmount, ref, watch, reactive, ComputedRef } from '@fwk-node-modules/vue'
import { getApp, useRouter, useStore } from '@fwk-client/utils/vue-3-migration';

import { enableIbox, disableIbox} from '@root/src/client/theme/inspinia-jquery'; 

import { useGenericPage } from '@fwk-client/composables/useGenericPage';

import PageTitle from '@root/src/client/components/panels/PageTitle.vue';
import Header from '../panels/Header.vue';
import CheckedFiles from '../panels/CheckedFiles.vue';
import GeneratedFiles from '../panels/GeneratedFiles.vue';

import { useModuleAdmin } from '../../composables/useModuleAdmin';

export default defineComponent({
  props: {
  },
  components: {
    PageTitle,
    CheckedFiles,
    GeneratedFiles,
    Header
  },
  setup(props, context) {
    const app = getApp();
    const $router = useRouter();
    const $store = useStore();

    const filesContent:Ref<HTMLElement|null> = ref(null);

    const genericPage = useGenericPage(props, context);
    const { modules, selectedModule } = useModuleAdmin(props, context);

    const breadcrumbs = [{
      label: app.$t('home.dashboard')
    },
    {
      label: app.$t('intrastats.title')
    }]

    onMounted(() => {
      enableIbox(filesContent.value!);
    })

    onBeforeUnmount(() => {
      disableIbox(filesContent.value!);
    })

    return {
      filesContent,
      breadcrumbs,
      selectedModule
    }
  }
});
</script>